import React, { useEffect } from 'react';
import Header from '../Layout/Header';
import { useDispatch, useSelector } from 'react-redux';
import { allapiAction } from '../../Redux/common/action';
import { useNavigate } from 'react-router-dom';

function Settings() {

  const get_profile = useSelector((state) =>
        state?.allapi?.get_profile ? state?.allapi?.get_profile : {}
      );

      const dispatch = useDispatch();
    
      useEffect(() => {
        // dispatch(allapiAction.vendordeshBoradData({}));
        // dispatch(allapiAction.categoryWiseSale({}));
        // dispatch(allapiAction.deshBoradDataUserData());
        dispatch(allapiAction.getprofile());
    
        return () => {};
      }, []);
const navigate = useNavigate();

      const hendletoLogout =async()=>{

        window?.localStorage.removeItem("access_token");
        window?.localStorage.removeItem("access_token_vendor");
        window?.localStorage.removeItem("access_user");
        localStorage.clear();
        navigate("/login");
      }



  return (
    <div className="settings-page">
      <Header />
      <div className="logout_treasure mt-5">
        <div className="container">
          {/* Profile Card */}
          <div className="profile-card">
            <img src="profile.jpg" alt="Profile" className="profile-pic" />
            <h5>{get_profile?.fullName} <span>&#128274;</span></h5>
            <p>Points: {get_profile?.earningbalance  ?get_profile?.earningbalance  :0}&#x25B6;</p>
          </div>

          {/* Verification & Settings */}
          {/* <div className="row text-center mt-3">
            <div className="col-6">
              <i className="fas fa-shield-alt"></i>
              <p><strong>Google Verification</strong></p>
              <p className="text-danger">Not bound</p>
            </div>
            <div className="col-6">
              <i className="fas fa-user-cog"></i>
              <p><strong>User Settings</strong></p>
            </div>
          </div> */}

          {/* Settings Buttons */}
          {/* <div className="list-group mt-3">
            <button className="list-group-item">🔒 Change Password</button>
            <button className="list-group-item">📊 Line Settings</button>
          </div> */}

          {/* <p className="text-center mt-5">Version v2.7.9</p> */}

          {/* Logout & Delete Buttons */}
          <div className="button-container">
            <button className="gradient-btn" onClick={hendletoLogout}>Log Out</button>
            {/* <button className="gradient-btn delete-btn">Delete Account</button> */}
          </div>
        </div>
      </div>
      <div style={{ height: "100px" }}></div>
    </div>
  );
}

export default Settings;
